var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSort = function SvgSort(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#1D352A"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.46 26.585V10h-1.914v16.585l-2.197-2.29L10 25.705l3.828 4a.936.936 0 0 0 1.043.22c.112-.056.214-.132.301-.225l3.828-4-1.35-1.41-2.19 2.295ZM26.172 10.295a.943.943 0 0 0-.49-.275.919.919 0 0 0-.553.055 1.046 1.046 0 0 0-.301.225L21 14.3l1.35 1.41 2.19-2.295V30h1.915V13.415l2.196 2.29L30 14.295l-3.828-4Z"
  }))));
};
export default SvgSort;